import React, { Component } from "react";
import { connect } from 'react-redux';
import { sendPasswordResetEmail } from "../../../store/actions/authActions";

const formLabelStyle = {
    fontSize: "12px",
    fontWeight: "bold",
};

class ResetPasswordForm extends Component {
    constructor(props) {
        super(props)

        this.state = {
            email: "",
        }
    }

    handleChange = (e) => {
        this.setState({
            [e.target.id]: e.target.value
        });
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.sendPasswordResetEmail(this.state);
    }

    render() {
        // console.log(this.props);
        const { message, showLoader } = this.props.auth;
        const relevantSubmitComponent = showLoader && !message ?
            <button className="btn btn-flat btn-dark btn-sm" type="button" disabled>
                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                &nbsp; Sending you a link
            </button> : <button className="btn btn-dark btn-sm" type="submit">Send me reset link</button>;

        return (
            <div className="container">
                <div className="card">
                    <h5 className="card-header"><b>Reset password</b></h5>
                    <div className="card-body">
                        <form onSubmit={this.handleSubmit}>

                            {/* EMAIL */}
                            <div className="form-group text-left">
                                <label htmlFor="email" style={formLabelStyle}>Email</label>
                                <input type="email" className="form-control" id="email" onChange={this.handleChange} />
                            </div>

                            {/* MESSAGE */}
                            <p style={{ color: "black", fontWeight: "bold", fontSize: "13px" }}>{message ?? ""}</p>

                            {/* RESET PASSWORD BUTTON */}
                            {relevantSubmitComponent}
                        </form>
                    </div>
                </div>
            </div>
        );
    }

}

const mapStateToProps = (state) => {
    // console.log(state.auth)
    return {
        auth: state.auth,
        themeColors: state.theme,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        sendPasswordResetEmail: (credentials) => dispatch(sendPasswordResetEmail(credentials)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ResetPasswordForm);